import { SelectOption } from 'components/ui/Select/types';

export const prepareCategories = (categories: BULLZ.GetCategoriesResponse): SelectOption[] =>
    categories?.items
        ? categories.items.map(category => ({
              value: category.tagId || '',
              label: `${category.emojiCode} ${category.translation?.displayName}`
          }))
        : [];
